import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { NotACashGrabSection } from '../components/NotACashGrabSection';
import { ChillsSection } from '../components/ChillsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { AverageRatingSection } from '../components/AverageRatingSection';
import { TestimonialsGridSection } from '../components/TestimonialsGridSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SocialProofNotification } from '../components/SocialProofNotification';
export const LandingV1 = () => <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-1421">
    <Header data-id="element-1422" />
    <main data-id="element-1423">
      <HeroSection data-id="element-1424" />
      <NotACashGrabSection data-id="element-1425" />
      <ChillsSection data-id="element-1426" />
      <WhatsInsideSection data-id="element-1427" />
      <SocialProofSection data-id="element-1428" />
      <PricingSection data-id="element-1429" />
      <AverageRatingSection data-id="element-1430" />
      <TestimonialsGridSection data-id="element-1431" />
      <UrgencySection data-id="element-1432" />
      <FAQSection data-id="element-1433" />
    </main>
    <Footer data-id="element-1434" />
    <SocialProofNotification data-id="element-1435" />
  </div>;